// extracted by mini-css-extract-plugin
export default {"card":"style_card__D3ZMR","card__titleBlock":"style_card__titleBlock__uvCM0","card__title":"style_card__title__o7ul4","card__text":"style_card__text__VBSx6"};